import React, { useState } from "react";
import { Button, Input, Modal } from "../ui";
import content from "../../services/api-content";
import { useToast } from "../../context/ToastContext";

const CATS = [
  ["inappropriate", "เนื้อหา/รูปภาพไม่เหมาะสม"],
  ["minor", "เกี่ยวข้องกับผู้เยาว์หรือเนื้อหา 18+"],
  ["violence", "ความรุนแรง / การคุกคาม"],
  ["copyright", "ละเมิดลิขสิทธิ์"],
  ["privacy", "เปิดเผยข้อมูลส่วนบุคคล / ใช้รูปบุคคลจริง"],
  ["spam", "สแปม / หลอกลวง"],
  ["other", "อื่น ๆ"],
];

/** รายงานเนื้อหา: targetType = user | character | comment | universe | post */
export default function ReportModal({ open, onClose, targetType, targetId, title = "รายงาน" }) {
  const toast = useToast();
  const [category, setCategory] = useState("");
  const [details, setDetails] = useState("");
  const [contact, setContact] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    if (!category) return setError("กรุณาเลือกประเภทการรายงาน");
    setBusy(true);
    setError("");
    try {
      await content.report({ targetType, targetId, category, details: details.slice(0, 1000), ...(contact ? { contact } : {}) });
      toast("ส่งรายงานแล้ว ขอบคุณที่ช่วยดูแลชุมชน", "success");
      setCategory(""); setDetails(""); setContact("");
      onClose();
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title={title} footer={<><Button variant="ghost" onClick={onClose}>ยกเลิก</Button><Button variant="primary" onClick={submit} disabled={busy}>{busy ? "กำลังส่ง..." : "ส่งรายงาน"}</Button></>}>
      <div className="stack" role="radiogroup" aria-label="ประเภทการรายงาน">
        {CATS.map(([v, label]) => (
          <label key={v} className="check"><input type="radio" name="report-cat" checked={category === v} onChange={() => setCategory(v)} /> {label}</label>
        ))}
      </div>
      <div className="mt-16">
        <Input multiline label="รายละเอียดเพิ่มเติม" maxLength={1000} value={details} onChange={(e) => setDetails(e.target.value)} hint={`${details.length}/1000`} />
        <Input label="ช่องทางติดต่อกลับ (ไม่บังคับ)" value={contact} onChange={(e) => setContact(e.target.value)} />
      </div>
      {error ? <div className="error-text" role="alert">{error}</div> : null}
    </Modal>
  );
}
